import {ensureArray, logger} from 'tizra'
import {useApi} from './useApi'

const log = logger('quickstart/hooks/useTypeDefs')

export const useTypeDefs = (metaType?: string | string[]) =>
  useApi.searchTypes(metaType && {metaType: ensureArray(metaType)}).data
